import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=dbe46a00"
import script from "./p01.vue?vue&type=script&lang=js"
export * from "./p01.vue?vue&type=script&lang=js"
import style0 from "./p01.vue?vue&type=style&index=0&id=dbe46a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports